import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";

import { queryClient } from "@/lib/api/query-client";
// Effet de bord : déclare les créations offline-capable (file d'écritures).
// DOIT précéder offline-boot : restaurer une écriture en file suppose que ses
// `mutationDefaults` (fonction de rejeu) sont déjà déclarés.
import "@/lib/api/offline-registry";
// Effet de bord : restaure la session de l'onglet (survie au rechargement hors
// ligne), rejoue la file en attente et maintient l'instantané à jour.
import "@/lib/api/offline-boot";
import { router } from "@/routes";

export function App() {
  // L'état de la connexion (hors ligne, serveur absent, lenteur, retour) et
  // l'arrivée d'une nouvelle version sont signalés par <ConnectionBanner />.
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster position="top-right" richColors closeButton toastOptions={{ style: { borderRadius: 0 } }} />
    </QueryClientProvider>
  );
}
